import { useAuth } from '@/hooks/use-auth';
import { AppHeader } from '@/components/app-header';

interface AppLayoutProps {
    children: React.ReactNode;
    hasOrdersCapability: boolean;
    brandName?: string;
    phone?: string;
    aiAgentEnabled: boolean;
    aiAgentPaused: boolean;
    hasBrand: boolean;
    onToggleAiAgent: (paused: boolean) => Promise<void>;
    pendingOrdersCount?: number;
    handoffCount?: number;
}

export function AppLayout({
    children,
    hasOrdersCapability,
    brandName,
    phone,
    aiAgentEnabled,
    aiAgentPaused,
    hasBrand,
    onToggleAiAgent,
    pendingOrdersCount,
    handoffCount,
}: AppLayoutProps) {
    const { session, logout } = useAuth();

    return (
        <div className="h-dvh flex flex-col">
            <AppHeader
                session={session}
                onLogout={logout}
                hasOrdersCapability={hasOrdersCapability}
                brandName={brandName}
                phone={phone}
                aiAgentEnabled={aiAgentEnabled}
                aiAgentPaused={aiAgentPaused}
                hasBrand={hasBrand}
                onToggleAiAgent={onToggleAiAgent}
                pendingOrdersCount={pendingOrdersCount}
                handoffCount={handoffCount}
            />
            <div className="flex-1 flex overflow-hidden relative">{children}</div>
        </div>
    );
}
